function bootstrapTooltip() {
  return {
    restrict: "A",
    scope: {
      bootstrapTooltip: "@",
    },
    link: function (scope, element, atributes) {
      if (atributes.tooltipOnOverflow !== undefined) {
        scope.$watch(
          () => element[0].scrollWidth,
          () => {
            if (hasOverflown(element)) {
              setTooltip(element, scope.bootstrapTooltip);
            }
          }
        );
      } else {
        setTooltip(element, scope.bootstrapTooltip);
      }
    },
  };
}

function setTooltip(element, tooltip) {
  element.tooltip({
    trigger: "hover",
    title: tooltip,
  });
}

function hasOverflown(element) {
  const visibleWidth = element[0].clientWidth,
    contentWidth = element[0].scrollWidth;
  return contentWidth > visibleWidth;
}

export default bootstrapTooltip;
